const ShareModalContent = () => {
    return(
        <div>공유 모달 컨텐츠</div>
    )
}

export default ShareModalContent